var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("The seller has provided tracking information for this transaction:")]),_c('GL-InfoItem',{attrs:{"label":"Courier Company Name","value":this.trackingInfo.name}}),_c('GL-InfoItem',{attrs:{"label":"Tracking number","value":this.trackingInfo.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }